var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlugandplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 70,
    viewBox: "0 0 62 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_20285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51363 0.0605469C2.23199 0.0605469 0.371094 1.93896 0.371094 4.24206V50.2387C0.371094 52.5418 2.23199 54.4203 4.51363 54.4203H23.8454V43.2696H7.27531V7.02974H29.3688V13.9989H36.273V4.24206C36.273 1.93896 34.4121 0.0605469 32.1305 0.0605469H4.51363ZM29.3688 15.3928C27.0872 15.3928 25.2263 17.2712 25.2263 19.5743V65.571C25.2263 67.8741 27.0872 69.7525 29.3688 69.7525H56.9857C59.2673 69.7525 61.1282 67.8741 61.1282 65.571V19.5743C61.1282 17.2712 59.2673 15.3928 56.9857 15.3928H29.3688ZM32.1305 22.362H54.224V58.6019H32.1305V22.362ZM18.3221 46.0572C19.4655 46.0572 20.3933 46.9938 20.3933 48.148C20.3933 49.3023 19.4655 50.2387 18.3221 50.2387C17.1785 50.2387 16.2508 49.3023 16.2508 48.148C16.2508 46.9938 17.1785 46.0572 18.3221 46.0572ZM43.1772 61.3895C44.3208 61.3895 45.2485 62.326 45.2485 63.4802C45.2485 64.6345 44.3208 65.571 43.1772 65.571C42.0338 65.571 41.106 64.6345 41.106 63.4802C41.106 62.326 42.0338 61.3895 43.1772 61.3895Z",
    fill: "url(#paint0_linear_2305_20285)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2305_20285",
    x1: 12.8353,
    y1: -0.0542543,
    x2: 66.0098,
    y2: 3.85331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_20285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.7571,
    height: 69.8707,
    fill: "white",
    transform: "translate(0.371094 0.0605469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugandplay);
export default __webpack_public_path__ + "static/media/plugandplay.14a5ceb64207ddb3a03fb4aee2e407d2.svg";
export { ForwardRef as ReactComponent };